module.exports = "data:image/png;base64,UklGRs4AAABXRUJQVlA4WAoAAAAQAAAAEwAAEAAAQUxQSIEAAAABf6G2kaQ2yRk8hDYjIiIAySBkWswZ5sqq5SNl1vxih4XZQUQAhMNIsk1rn/1t2/9P/vF9bQgR/Z8AjM+h4dzXf+tGf+0GoaRja7zc3t4um0lbH1lIUlrViX6EZay/gUPPwXMaGWDfdfCYZQY4jQIDbDoOXvPCANdpboDztDTAfQUAVlA4ICYAAADQAgCdASoUABEAPm00lkekIyIhKAgAgA2JaQAAPaOgAP77IYAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/growthThinking/list2/640(7).png
// module id = PPxy
// module chunks = 1